const Pricing = {
  mounted() {
    let priceFromUser = document.querySelector(`[data-pi]`);
    let priceId;
    if (priceFromUser !== null) {
      priceId = priceFromUser.getAttribute("data-pi");
      localStorage.removeItem("_collava_success");
    } else {
      priceId = localStorage.getItem("_collava_success");
    }

    if (priceId != "" && priceId != null) {
      document.querySelector("#period-selector").classList.add("hidden");
      let buttonPrice = document.querySelector(`[data-price-id=${priceId}]`);
      let buttonContainer = buttonPrice.parentElement;
      // disable the  all price current buttons
      document.querySelectorAll(".paddle_button").forEach((button) => {
        button.classList.add("hidden");
      });
      document.querySelectorAll(".change-plan").forEach((button) => {
        button.classList.remove("hidden");
      });
      buttonContainer.querySelector(".change-plan").classList.add("hidden");
      buttonContainer
        .querySelector(".button-current-plan")
        .classList.remove("hidden");
      buttonContainer
        .querySelector(".button-cancel-plan")
        .classList.remove("hidden");
    }
  },
};

export default Pricing;
